// Types
import type { GetStoreBySlug_store } from 'api/store/types/GetStoreBySlug';
// Helpers
import { parseToPlainText } from './textEditor';

export type StoreMetaData = {
  name: string;
  description: string;
  avatarUrl: string;
  metaTitle: string;
  metaDescription: string;
};

export const getStoreMetaData = (
  store?: GetStoreBySlug_store
): StoreMetaData => {
  const name = store?.storeDetails?.storeName || '';
  const description =
    store?.storeDetails?.description || store?.storeDetails?.bio || '';
  const avatarUrl = store?.storeDetails?.avatarURL || '';

  const metaTitle = `${name}: Streams, Merchandise, Personal Videos | MILLIONS`;
  const metaDescription = `${parseToPlainText(
    description
  )} ${name}: Watch live streams, buy ${name} merch, ask questions, and get answered on MILLIONS.`;

  return {
    name,
    description,
    avatarUrl,
    metaTitle,
    metaDescription,
  };
};
